<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form
          :inline="true"
          size="mini"
          label-width="100px"
          :model="searchForm"
          :rules="rules"
          ref="searchForm"
        >
          <el-form-item label="平台单号">
            <el-input v-model="searchForm.platCode" @keyup.enter.native="onSearch"/>
          </el-form-item>
          <el-form-item label="电商单号">
            <el-input v-model="searchForm.orderCode" @keyup.enter.native="onSearch"/>
          </el-form-item>
          <el-form-item label="平台">
            <el-select v-model="searchForm.platName" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in platNameList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺">
            <el-select v-model="searchForm.storeName" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in storeNameList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款时间">
            <el-date-picker v-model="searchForm.payTime" unlink-panels type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyyMMdd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="审核时间">
            <el-date-picker v-model="searchForm.auditTime" unlink-panels type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyyMMdd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select v-model="searchForm.billStatusDesc" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in billStatusDescList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品发货状态">
            <el-select v-model="searchForm.sendStatus" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in sendStatusList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="SKU编码">
            <el-input v-model.trim="searchForm.skuCode" @keyup.enter.native="onSearch"/>
          </el-form-item>
          <el-form-item label="SKU名称">
            <el-input v-model.trim="searchForm.skuName" @keyup.enter.native="onSearch"/>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch"
            >搜索</el-button
          >
          <el-button class="orange-btn" size="mini" @click="reset"
            >重置</el-button
          >
        </template>
      </search-box>
    </template>


    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="dispose" v-permission="`ec-pc-new$orderManagement$orderManagement$orderVerification$dispose`">配置</el-button>
        <el-button class="orange-btn" size="mini" @click="passThrough(false)">通过</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        :row-key=" (row) => { return row.dataId; } "
      >
        <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column
          v-for="(item, index) in columnData"
          :key="item.columnName + index"
          :align="`${item.fieldType == 'string' ? 'left' : 'right'}`"
          show-overflow-tooltip
          :label="item.displayName"
          :fixed="item.freezeType"
          :prop="item.columnName"
          :min-width="item.displayWidth"
        >
          <template slot-scope="scope">
            {{ scope.row[item.columnName] | cellValFormat }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="passThrough(scope.row)"
              >通过</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <edit-dialog
      :visible.sync="isShowDispose"
      v-if="isShowDispose"
      :priceRatio="priceRatio"
      @success="onSearch"
    />
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin';
import axios from "@/utils/axiosInstance";
import { downloadFile } from "@/utils";
import editDialog from "./edit.vue";
import moment from "moment";
export default {
  name: "OrderVerification",
  mixins: [tableMixin, pagePathMixin],
  components: { editDialog },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      reportName: "goodsCheckInfoReport",
      columnData: [],
      loading: false,
      searchForm: {
        platName: "",
        storeName: "",
        billStatusDesc: "",
        sendStatus: "",
      },
      exportData: {},
      searchCollapse: false,
      isShowDispose: false,
      selectionVal: [],
      queryCriteria: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
      platNameList: [],
      storeNameList: [],
      billStatusDescList: [],
      sendStatusList: [],
      priceRatio: "",
    };
  },
  computed: { },
  methods: {
    columns() {
      this.loading = true;
      this.$q.goods
        .columns({ params: { reportName: this.reportName } })
        .then((res) => {
          this.columnData = res.data.sysColumns;
          this.init();
        });
    },
    onSearch() {
      let platCodeType = this.searchForm.platCode && this.searchForm.platCode.split(" ").length > 1000
      let orderCode = this.searchForm.orderCode && this.searchForm.orderCode.split(" ").length > 1000
      let skuCode = this.searchForm.skuCode && this.searchForm.skuCode.split(" ").length > 1000
      if(platCodeType || orderCode || skuCode) {
        this.$message.error('已超过1000条，请核对！')
        return
      }
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: "platCode", //平台单号
          val: this.searchForm.platCode ? this.searchForm.platCode.split(" ") : [],
          op: "in",
        },
        {
          attributeName: "orderCode", //电商单号
          val: this.searchForm.orderCode ? this.searchForm.orderCode.split(" ") : [],
          op: "in",
        },
        {
          attributeName: "platName", //平台
          val: [this.searchForm.platName ? this.searchForm.platName : ""],
          op: "in",
        },
        {
          attributeName: "storeName", //店铺
          val: [this.searchForm.storeName ? this.searchForm.storeName : ""],
          op: "in",
        },
        {
          attributeName: "payTimeQuery", //付款时间
          val: this.searchForm.payTime && this.searchForm.payTime.length ? this.searchForm.payTime : [],
          op: "range",
        },
        {
          attributeName: "auditTimeQuery", //审核时间
          val: this.searchForm.auditTime && this.searchForm.auditTime.length ? this.searchForm.auditTime : [],
          op: "range",
        },
        {
          attributeName: "billStatusDesc", //订单状态
          val: [this.searchForm.billStatusDesc  ? this.searchForm.billStatusDesc  : "",],
          op: "in",
        },
        {
          attributeName: "sendStatus", //商品发货状态
          val: [this.searchForm.sendStatus ? this.searchForm.sendStatus : ""],
          op: "in",
        },
        {
          attributeName: "skuCode", //sku编码
          val: this.searchForm.skuCode ? this.searchForm.skuCode.split(" ") : [],
          op: "in",
        },
        {
          attributeName: "skuName", //sku名称
          val: this.searchForm.skuName ? this.searchForm.skuName : "",
          op: "like",
        },
      ];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter(
        (item) => item.val.length && item.val[0]
      );
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: "",
        orderType: "",
        hasCount: "Y",
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            if (!type) {
              this.tableReload = false;
              this.$nextTick((_) => {
                this.tableReload = true;
              });
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },

    handleSelectionChange(val) {
      this.selectionVal = val;
    },

    reset() {
      if (this.$refs["table"]) {
        this.$refs["table"].clearSort(); //切换清除排序
      }
      // this.filterPropertyName = [];
      this.searchForm = {
        platName: "",
        storeName: "",
        billStatusDesc: "",
        sendStatus: "",
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    dispose() {
      this.isShowDispose = true;
    },

    async passThrough(row) {
      let selectionType = !row && !this.selectionVal.length;
      if (selectionType) {
        this.$message.error("请选择后在进行操作！");
        return;
      }
      let status = await this.$confirm("是否确认通过？", "提示", {
        type: "warning",
      });
      if (status !== "confirm") return;
      let data = {
        dataIdList: !row
          ? this.selectionVal.map((v) => v.dataId)
          : [row.dataId],
      };
      let res = await this.$q.smallHomeAppliances.checkPass({ data: data });
      if (res.success) {
        this.$message.success("通过成功");
      } else {
        this.$message.fail(res.message);
      }
      this.onSearch();
    },

    getPlatNameList() {
      let data = { ...this.currencyForm };
      data.reportCode = this.reportName;
      data.groupAttr = "platName";
      data.hasCount = "Y";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.platNameList = data;
      });
    },
    getStoreNameList() {
      let data = { ...this.currencyForm };
      data.reportCode = this.reportName;
      data.groupAttr = "storeName";
      data.hasCount = "Y";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.storeNameList = data;
      });
    },
    getBillStatusDescList() {
      let data = { ...this.currencyForm };
      data.reportCode = this.reportName;
      data.groupAttr = "billStatusDesc";
      data.hasCount = "Y";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.billStatusDescList = data;
      });
    },
    getSendStatusList() {
      let data = { ...this.currencyForm };
      data.reportCode = this.reportName;
      data.groupAttr = "sendStatus";
      data.hasCount = "Y";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.sendStatusList = data;
      });
    },

    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        taskDTO: {
          appCode: "ec-pc-new",
          paramMap: this.searchFormData,
          reportName: this.reportName,
        },
        columnDTOs: null,
      };
      let tmp = JSON.parse(JSON.stringify(this.columnData));

      params.columnDTOs = tmp.map((item) => {
        return {
          columnName: item.displayName,
          fieldName: item.columnName,
          fieldType: item.fieldType,
          columnFormat: item.columnFormat,
        };
      });
      params.columnDTOs = params.columnDTOs.filter(
        (v) => v.columnName !== "图片"
      );
      this.$q.common
        .customExportExcel({ data: params })
        .then((res) => {
          this.$message({
            type: "success",
            message: "导出成功,请在导出列表中查看",
          });
        }).finally(_=>{
          loading.close();
        })
        .catch((err) => {});
    },
    configRatioGet() {
      this.$q.smallHomeAppliances.configRatioGet().then((res) => {
        this.priceRatio = res.data;
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
  mounted() {
    this.getPlatNameList();
    this.getStoreNameList();
    this.getBillStatusDescList();
    this.getSendStatusList();
    this.configRatioGet();
    this.columns();
  },
};
</script>

<style lang="stylus" scoped>
// >>> .el-form-item {
//   margin-bottom: 10px;
// }

</style>
